document.addEventListener('DOMContentLoaded', function() {
  const logo = document.querySelector('.logo');
  if (logo) {
    logo.style.position = 'relative';
    var badge = document.createElement('span');
    badge.textContent = '服务商';
    badge.style.cssText = 'position:absolute;top:-12px;right:-48px;font-size:12px;background:linear-gradient(135deg,#ff6b35,#ff4500);color:#fff;padding:2px 6px;border-radius:3px;line-height:1.4;white-space:nowrap;pointer-events:none;font-weight:500;letter-spacing:0.5px;';
    logo.appendChild(badge);
  }

  const header = document.querySelector('.header');
  const mobileToggle = document.querySelector('.mobile-toggle');
  const nav = document.querySelector('.nav');

  window.addEventListener('scroll', function() {
    if (window.scrollY > 50) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  });

  if (mobileToggle && nav) {
    mobileToggle.addEventListener('click', function() {
      nav.classList.toggle('open');
    });

    document.querySelectorAll('.nav-link').forEach(function(link) {
      link.addEventListener('click', function() {
        nav.classList.remove('open');
      });
    });
  }

  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });

  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1
  };

  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
      }
    });
  }, observerOptions);

  document.querySelectorAll('.feature-card, .section').forEach(function(el) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
    observer.observe(el);
  });

  // FAQ accordion functionality
  document.querySelectorAll('.faq-question').forEach(function(question) {
    question.addEventListener('click', function() {
      const answer = this.nextElementSibling;
      const isActive = this.classList.contains('active');

      // Close all other answers
      document.querySelectorAll('.faq-question').forEach(function(q) {
        q.classList.remove('active');
        q.nextElementSibling.classList.remove('active');
      });

      // Toggle current
      if (!isActive) {
        this.classList.add('active');
        answer.classList.add('active');
      }
    });
  });
});
